<script setup lang="ts">
    import type { CollapsibleContentProps } from 'reka-ui';
    import { CollapsibleContent } from 'reka-ui';

    const props = defineProps<CollapsibleContentProps>();
</script>

<template>
    <CollapsibleContent
        data-slot="collapsible-content"
        class="CollapsibleContent"
        v-bind="props"
    >
        <slot />
    </CollapsibleContent>
</template>

<style lang="css" scoped>
    .CollapsibleContent {
        overflow: hidden;
    }
    .CollapsibleContent[data-state='open'] {
        animation: slideDown 300ms ease-out;
    }
    .CollapsibleContent[data-state='closed'] {
        animation: slideUp 300ms ease-out;
    }

    @keyframes slideDown {
        from {
            height: 0;
        }
        to {
            height: var(--reka-collapsible-content-height);
        }
    }

    @keyframes slideUp {
        from {
            height: var(--reka-collapsible-content-height);
        }
        to {
            height: 0;
        }
    }
</style>
